@if (tourService.promptVisible() && tourService.promptTour(); as tour) {
  <div class="tour-prompt-backdrop" (click)="dismiss()">
    <div class="tour-prompt-card" (click)="$event.stopPropagation()">
      <div class="tour-prompt-icon">
        <span class="pi pi-compass"></span>
      </div>
      <h2>{{ tour.promptTitle }}</h2>
      <p>{{ tour.promptBody }}</p>
      <div class="tour-prompt-actions">
        <button type="button" class="tour-prompt-btn tour-prompt-btn-secondary" (click)="dismiss()">
          Maybe later
        </button>
        <button type="button" class="tour-prompt-btn tour-prompt-btn-primary" (click)="startTour()">
          Start tour
        </button>
      </div>
    </div>
  </div>
}
